import { create } from 'zustand';
import { combine, subscribeWithSelector } from 'zustand/middleware';
import enUS from './translations/en-US.json';

type CometChatSupportedLocale = 'en-US';

export type TranslationResource = typeof enUS;

interface TranslationState {
  translations: Record<string, typeof enUS>;
  currentLocale:
    | CometChatSupportedLocale
    | Omit<string, CometChatSupportedLocale>;
}

const initialState: TranslationState = {
  translations: {
    'en-US': enUS,
  },
  currentLocale: 'en-US',
};

export const useTranslationStore = create(
  subscribeWithSelector(
    combine(initialState, set => ({
      reset: () => set(initialState),
      setLocale: (locale: CometChatSupportedLocale) =>
        set(() => ({
          currentLocale: locale,
        })),
    })),
  ),
);
